import { type InputBaseComponentProps, Stack } from "@mui/material";
import { Input, Text } from "@src/appV2/redesign/system/ui-components";
import { type FunctionComponent, type ReactElement, useState } from "react";
import { useController } from "react-hook-form";

import { MaskedPhoneInput } from "./MaskedPhoneInput";

interface PhoneFieldProps {
  name: string;
  onMaxLengthAttempt?: () => void;
  showLabel?: boolean;
  label?: string;
}

export function PhoneField(props: PhoneFieldProps): ReactElement {
  const { name, onMaxLengthAttempt, showLabel = true, label = "Enter your phone number:" } = props;
  const [isFocused, setIsFocused] = useState(false);

  const {
    field,
    fieldState: { error },
    formState: { isSubmitting },
  } = useController({
    name,
  });

  return (
    <Stack spacing={1}>
      {showLabel && (
        <Text
          semibold
          variant="body1"
          sx={{ color: (theme) => theme.palette.text.secondary, paddingLeft: 1, paddingBottom: 2 }}
        >
          {label}
        </Text>
      )}
      <Input
        {...field}
        fullWidth
        type="tel"
        inputProps={{
          "aria-label": "Phone number",
          ...(onMaxLengthAttempt && { onMaxLengthAttempt }),
        }}
        placeholder={isFocused ? "(123) 456 - 7890" : "Enter your phone number"}
        disabled={isSubmitting}
        size="large"
        error={Boolean(error)}
        inputComponent={MaskedPhoneInput as unknown as FunctionComponent<InputBaseComponentProps>}
        iconType="phone"
        onFocus={() => {
          setIsFocused(true);
        }}
        onBlur={() => {
          setIsFocused(false);
        }}
      />
      {error && (
        <Text variant="caption" color="error" sx={{ paddingLeft: 1 }}>
          {error?.message}
        </Text>
      )}
    </Stack>
  );
}
